import axios, { AxiosError } from "axios";
import { API_URL, PolicyRenewalResult, PolicyRenewalSaveRequest } from "../constant";

export async function api_save_policy_renewal(data: PolicyRenewalSaveRequest): Promise<PolicyRenewalResult> {
    const token = localStorage.getItem("token");

    try {
        const response = await axios.post(
            `${API_URL}api/user/savePolicyRenewal`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                validateStatus: (status: number) => status >= 200 && status < 500,
            },
        );

        if (response.status === 204) {
            return { bSuccess: true, msg: "Success to save policy renewal form" };
        }

        return { bSuccess: false, msg: response.data?.detail ?? "Unexpected status code" };
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { bSuccess: false, msg: `Server Error: ${error.response.status}` };
        } else if (error.request) {
            return { bSuccess: false, msg: "No response received from server" };
        }

        return { bSuccess: false, msg: `Error: ${error.message}` };
    }
}

export async function api_get_policy_renewal(fileid: number): Promise<PolicyRenewalResult> {
    const token = localStorage.getItem("token");

    try {
        const response = await axios.get(
            `${API_URL}api/user/getPolicyRenewal`,
            {
                params: { fileid },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                validateStatus: (status: number) => status >= 200 && status < 500,
            },
        );

        if (response.status === 200) {
            return { bSuccess: true, msg: "", formData: response.data };
        }

        return { bSuccess: false, msg: response.data?.detail ?? "Unexpected status code" };
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { bSuccess: false, msg: `Server Error: ${error.response.status}` };
        } else if (error.request) {
            return { bSuccess: false, msg: "No response received from server" };
        }

        return { bSuccess: false, msg: `Error: ${error.message}` };
    }
}
